export default __webpack_public_path__ + "static/media/fog.782a6e6a.png";